export default "__VITE_ASSET__636cc385__"